import React, { useState } from 'react';
import { Button, Box, Tooltip, Stack, Theme } from '@mui/material';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { CustomMuiIcon } from 'assets/images/icons/customMuiIcons';
import VideoFooterMenu from 'components/Menu/VideoFooterMenu/VideoFooterMenu';
import { VideoFooterMenuOption } from 'shared/types/video.interface';

interface ConferenceButtonProps {
  fullButton: boolean;
  tooltipTitle: string;
  onButtonClick: () => void;
  isButtonDisabled?: boolean;
  buttonIconType: string;
  isMenuAvailable: boolean;
  menuOptions: VideoFooterMenuOption[];
  onMenuItemClick: (key: any) => void;
}

export const ConferenceButton = (props: ConferenceButtonProps) => {
  const {
    fullButton,
    tooltipTitle,
    onButtonClick,
    isButtonDisabled,
    buttonIconType,
    isMenuAvailable,
    menuOptions,
    onMenuItemClick,
  } = props;
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <Stack
      position="relative"
      direction="row"
      sx={{
        ...(fullButton
          ? {
              width: { lg: '89px', md: '70px', sm: '70px', xs: '70px' },
            }
          : {
              width: { lg: '56px', md: '44px', sm: '44px', xs: '44px' },
            }),
        borderRadius: { lg: '8px', md: '6px', sm: '6px', xs: '6px' },
        boxShadow: (theme: Theme) => `0 0 4px 0 ${theme.palette.myShadow.button}`,
        transition: 'width ease-in-out 0.2s',
      }}
    >
      <Tooltip title={tooltipTitle} placement="top">
        <Button
          variant="conferenceIcon"
          onClick={onButtonClick}
          disabled={isButtonDisabled}
          disableRipple
        >
          <CustomMuiIcon
            type={buttonIconType}
            sx={{ fontSize: { lg: '28px', md: '22px', sm: '22px', xs: '22px' } }}
          />
        </Button>
      </Tooltip>
      {isMenuAvailable && (
        <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
          <Box>
            <Button
              variant="conferenceIcon"
              onClick={() => setMenuOpen((prev) => !prev)}
              disableRipple
              className="open-menu"
            >
              <CustomMuiIcon type="icon-button-more" size="16px" />
            </Button>
            <VideoFooterMenu
              isOpen={isMenuOpen}
              onClose={() => setMenuOpen(false)}
              menuOptions={menuOptions}
              onMenuItemClick={onMenuItemClick}
            />
          </Box>
        </ClickAwayListener>
      )}
    </Stack>
  );
};
